import { gql } from '@apollo/client';

import { GRAPHQL } from '../../constants';

export default gql`
    fragment productListFields on ProductList {
        title
        productIds
        ${GRAPHQL.URL_OBJECT}
    }
`;
